"use client";

import React from "react";
import { Network, Zap, PlugZap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const standardsData = [{
  title: "SD WAN",
  description: "Optimize your network with intelligent traffic routing. Our SD-WAN solutions ensure critical business applications always have the bandwidth they need while providing seamless failover across multiple providers.",
  icon: Zap
}, {
  title: "Primary Internet",
  description: "Dedicated, high-speed fiber, satellite, and wireless internet solutions designed for maximum uptime. We coordinate with top-tier carriers to deliver the reliable backbone your business operations demand.",
  icon: Network
}, {
  title: "Back Up Internet",
  description: "Eliminate downtime with automated secondary connections. Our LTE/5G and wireline failover solutions keep your business running smoothly even if your primary circuit goes dark.",
  icon: PlugZap
}];
export default function CablingStandards() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="241735" id="high-speed-business-internet" className="py-16 md:py-24 bg-card text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerReveal.ref} className={`text-center max-w-3xl mx-auto mb-12 md:mb-16 transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold font-default text-primary mb-4 tracking-tighter uppercase">
            High-Speed Internet & Connectivity Solutions
          </h2>
          <p className="text-xl font-default text-muted-foreground">Engineered for speed. We deploy mission-critical network infrastructures using our relationships with top carriers delivering both fiber and copper standards to power your business at the speed of light.</p>
        </div>

        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-700 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {standardsData.map((standard, index) => <Card key={index} data-index={index} className="border-border shadow-lg hover:shadow-2xl transition-all duration-300 bg-background h-full flex flex-col">
              <CardHeader className="pb-4">
                <div className="size-14 bg-secondary text-secondary-foreground flex items-center justify-center mb-5 shadow-md">
                  <standard.icon className="size-7" strokeWidth={2.5} />
                </div>
                <CardTitle className="text-2xl font-bold font-default text-foreground tracking-tight">
                  {standard.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-0 flex-grow">
                <p className="text-muted-foreground leading-relaxed font-default text-lg">
                  {standard.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}